module.exports = __webpack_public_path__ + "static/settings-5b71bf2b87d78e52a865df53f5d7f82b.png";